import { ZendeskAPI } from 'react-zendesk';
import { sendAnalyticsEvent } from '../analytics';

declare global {
  interface Window {
    zE: any;
  }
}

export const handleZendeskButtonClick = () => {
  ZendeskAPI('webWidget', 'open')

  ZendeskAPI('webWidget', 'setLocale', 'pt-BR')

  ZendeskAPI('webWidget', 'helpCenter:setSuggestions', { search: 'login' })

  sendAnalyticsEvent('zendesk_open')

  if (window?.zE) {
    window.zE('messenger:on', 'ticket:submit', function () {
      sendAnalyticsEvent('zendesk_submit')
    })
  }
}
